export const siteLogo = {
  logo: "/assets/images/elyse-k/ek-logo.png", // Add your site logo here
  alt: "Prosperity Elyse", // Add your site name here
};
export const socialLink = {
  youtube: "https://www.youtube.com/channel/UCFF12YUu0YOjkpsyHl5aMIg",
};
export const mailchimpLink = {
  // link: process.env.REACT_APP_MAILCHIMP, // Add your mailchimp list link here
  link: "https://app.us11.list-manage.com/subscribe/post-json?u=07c2821b1bf776eb4bf728a26&id=21c317dd0a&f_id=0002c7e3f0&c=?",
};
export const contactFormAction = {
  link: process.env.REACT_APP_CONTACTFORM, // Add for link here from https://formspree.io
};
export const contactMap = {
  link: process.env.REACT_APP_CONTACTMAP, // Add google map link from here: https://www.embedgooglemap.net/
};
